import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const CircleLockIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon
    width="16px"
    height="20px"
    viewBox="0 0 16 20"
    fill="none"
    data-testid="circle-lock-icon"
    {...props}
  >
    <path
      d="M6.5 14.0001C6.5 13.1717 7.17157 12.5001 8 12.5001C8.82843 12.5001 9.5 13.1717 9.5 14.0001C9.5 14.8285 8.82843 15.5001 8 15.5001C7.17157 15.5001 6.5 14.8285 6.5 14.0001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.62165 8.59725L3.30621 5.75828C3.26577 5.3943 3.26577 5.02696 3.30621 4.66298L3.32898 4.45809C3.57046 2.2847 5.27907 0.565038 7.45085 0.309534C7.81568 0.266614 8.18428 0.266614 8.5491 0.309534C10.7209 0.565038 12.4295 2.2847 12.671 4.45809L12.6937 4.66298C12.7342 5.02696 12.7342 5.3943 12.6937 5.75828L12.3783 8.59725L13.0649 8.65206C14.1476 8.73849 15.0317 9.5524 15.2073 10.6243C15.5733 12.8599 15.5733 15.1403 15.2073 17.3759C15.0317 18.4478 14.1476 19.2617 13.0649 19.3482L11.5688 19.4676C9.19339 19.6572 6.80666 19.6572 4.43128 19.4676L2.93515 19.3482C1.85242 19.2617 0.968319 18.4478 0.792803 17.3759C0.426732 15.1403 0.426732 12.8599 0.792803 10.6243C0.968319 9.5524 1.85242 8.73849 2.93515 8.65206L3.62165 8.59725ZM7.62611 1.79926C7.8745 1.77004 8.12545 1.77004 8.37384 1.79926C9.85246 1.97322 11.0157 3.14402 11.1802 4.62373L11.2029 4.82863C11.2311 5.08252 11.2311 5.33874 11.2029 5.59263L10.8818 8.48308C8.96256 8.3595 7.0374 8.3595 5.1182 8.48309L4.79704 5.59263C4.76883 5.33875 4.76883 5.08252 4.79704 4.82863L4.8198 4.62373C4.98422 3.14402 6.14749 1.97322 7.62611 1.79926ZM11.4494 10.0279C9.15347 9.84457 6.84658 9.84457 4.55065 10.0279L3.05452 10.1473C2.65959 10.1788 2.33711 10.4757 2.27309 10.8667C1.9333 12.9418 1.9333 15.0584 2.27309 17.1335C2.33711 17.5245 2.65959 17.8214 3.05452 17.8529L4.55065 17.9723C6.84658 18.1556 9.15347 18.1556 11.4494 17.9723L12.9455 17.8529C13.3405 17.8214 13.6629 17.5245 13.727 17.1335C14.0668 15.0584 14.0668 12.9418 13.727 10.8667C13.6629 10.4757 13.3405 10.1788 12.9455 10.1473L11.4494 10.0279Z"
      fill="currentColor"
    />
  </Icon>
);
